import React, { Component } from 'react';
import { Clouds } from './Clouds'
import { BottomClouds } from './BottomClouds'

import { FutoSpec } from './FutoSpec'
import { Mousetrap } from './Mousetrap'
import { GFL } from './GFL'
import { Management } from './Management'

import '../css/fonts.css';
import '../css/addlightness.css';

import oaklandSkyline from '../img/oakland-800.png'


export class CoverLetters extends Component {
  constructor(props) {
    super(props)

    this.SCROLL_THRESHOLD = 250
    this.SCROLL_THRESHOLD_2 = 500
    this.SCROLL_THRESHOLD_3 = 750

    this.SKYLINE_TOP_OFFSET = 2810

    this.state = {
      blur: false,
      whichBoxWasTriggered: "none",

      animPct: 1.0,
      animStartTime: null,
      animElapsed: null,

      opacity: 1.0,
      //opacity: 0.3,
      shadowPx: 8,
      anchorBlurShadowPx: 0,

      //cloudsFireTop: false,
      cloudsFireTop: true,
      hamburgerClicked: false,
    }

    this.SHADOW_PX_MAX = 18
    this.ANCHOR_BLUR_SHADOW_PX_MAX = 8

    this.ANIM_DECREMENT = 0.2
    this.ANIM_STEPS = 1.0 / this.ANIM_DECREMENT
    this.ANIM_INTERVAL_MS = 15
    this.ANIM_DURATION = this.ANIM_STEPS * this.ANIM_INTERVAL_MS

    this.animIntervalId = null;
    this.startAnimation = this.startAnimation.bind(this)
    this.stopAnimation = this.stopAnimation.bind(this)
    this.doAnimInterval = this.doAnimInterval.bind(this)

    this.blurFunc = this.blurFunc.bind(this)
    this.unBlurFunc = this.unBlurFunc.bind(this)

    this.handleHamburgerClick = this.handleHamburgerClick.bind(this)
  }

  handleHamburgerClick(ev) {
    const triggerIds = [
      'hamburger-img',
      'burger-menu',
    ]

    if ( triggerIds.includes(ev.target.id)
      || ev.target.className === 'burger-menu-item'
    ) {
      this.setState({ hamburgerClicked: true })
    } else {
      this.setState({ hamburgerClicked: false })
    }
  }

  renderClouds(marginTop=0, offset=true) {
    console.log("clouds() with marginTop: " + marginTop)
    const cloudsContainerStyle = {
      top: marginTop,
    }

    return (
        <div style={cloudsContainerStyle}>
          <Clouds offset={offset}/>
        </div>
    )
  }


  blurFunc(elem) {
    //console.log("blurFunc for tag: " + elem)
    this.startAnimation(elem)
  }


  unBlurFunc() {
    //console.log("unBlur()")
    this.setState({
      blur: false,
      opacity: 1.0,
      shadowPx: 0,
      whichBoxWasTriggered: "none",
    })
  }


  startAnimation(elem) {
    //console.log("startAnimation() for elem: " + elem)
    this.animIntervalId = setInterval(() =>
      this.doAnimInterval(),
      this.ANIM_INTERVAL_MS
    )

    this.setState({
      blur: true,
      whichBoxWasTriggered: elem,
      animStartTime: Date.now(),
      animPct: 1.0,
    })
  }


  stopAnimation() {
    //console.log("stopAnimation() for animIntervalId: " + this.animIntervalId)
    clearInterval(this.animIntervalId)
    this.setState({
      animStartTime: null,
      animElapsed: 0,
      animPct: 1.0,
    })
  }


  doAnimInterval() {
    //console.log("animation interval with elapsed: " + this.state.animElapsed)
    if ( this.state.animElapsed >= this.ANIM_DURATION ) {
      //console.log("animPct <= 0")
      this.stopAnimation()
    } else {
      // issues with when number gets close to 0. Maybe a JS float problem.
      let newPct = this.state.animPct - this.ANIM_DECREMENT
      if ( newPct < 0.0 ) {
        newPct = 0
      }

      const newOpacity = this.state.opacity - this.ANIM_DECREMENT
      const newShadowPx = this.SHADOW_PX_MAX * ( 1 - newPct )
      const newAnchorBlurShadowPx = this.ANCHOR_BLUR_SHADOW_PX_MAX * ( 1 - newPct )
      const newElapsedTime = this.state.animElapsed + this.ANIM_INTERVAL_MS

      //console.log(`animation interval decremented animPct: ${newPct}`)
      this.setState({
        animPct: newPct,
        opacity: newOpacity,
        shadowPx: newShadowPx,
        anchorBlurShadowPx: newAnchorBlurShadowPx,
        animElapsed: newElapsedTime,
      })
    }
  }


  render() {

    const reactiveAlFontSize = window.innerWidth < 506 ? '80px' : '138px'
    //const reactiveAlTop = window.innerWidth < 506 ? '90px' : ''

    let alHeaderStyle = {
      fontFamily: 'BeyondInfinity',
      fontSize: reactiveAlFontSize,
      color: `rgba(31, 85, 125, ${this.state.opacity})`,
      //color: 'yellow',
      textShadow: `0 0 ${this.state.shadowPx}px #1F557D`,
      //textShadow: `0 0 ${this.state.shadowPx}px yellow`,

      position: 'absolute',
      marginTop: '150px',
    }

    const reactiveBulletSize = window.innerWidth < 506 ? '20px' : '28px'
    const reactiveBulletMarginTop = window.innerWidth < 506 ? '250px' : '300px'

    let bulletStyle = {
      fontFamily: "Geo Sans Light Oblique",
      fontWeight: 700,
      fontSize: reactiveBulletSize,
      marginTop: reactiveBulletMarginTop,
      color: '#1f557d',
      position: 'absolute',
    }

    const reactiveChapmanFontSize = window.innerWidth < 506 ? '12px' : '16px'
    const reactiveChapmanInnerFontSize = window.innerWidth < 506 ? '8px' : '12px'
    //const topOffset = window.innerHeight - 120
    const topOffset = 700

    let chapmanContainerStyle = {
      position: 'absolute',
      top: `${topOffset}px`,
      fontFamily: 'Geometos',

    }

    let chapmanQuoteStyle = {
      fontSize: reactiveChapmanFontSize,
      color: `rgba(31, 85, 125, ${this.state.opacity})`,
      //textShadow: `0 0 ${this.state.shadowPx}px #1F557D`,
    }

    let chapmanNameStyle = {
      fontSize: reactiveChapmanInnerFontSize,
      color: `rgba(31, 85, 125, ${this.state.opacity})`,
      marginTop: '10px',
      marginLeft: '200px',
      //textShadow: `0 0 ${this.state.shadowPx}px #1F557D`,
    }

    const skylineTop = this.SKYLINE_TOP_OFFSET
    //const skylineWidth = window.innerWidth > 506 ? 700 : window.innerWidth
    const skylineWidth = window.innerWidth

    const skylineContainerStyle = {
      position: 'absolute',
      top: `${skylineTop}px`,
    }

    const sunDim = window.innerWidth > 506 ? 170 : 70
    const sunTop = window.innerWidth > 506 ? skylineTop - 90 : skylineTop - 50
    const sunRight = window.innerWidth > 506 ? 150 : 50
    //const sunColor = '#fefe75'
    //const sunColor = '#f5f569'
    //const sunColor = '#f5f59a'
    //const sunColor = '#fafa91'
    //const sunColor = '#f7f7a8'
    const sunColor = '#fcfc92'

    const yellowSunStyle = {
      position: 'absolute',
      //border: `2px solid ${sunColor}`,
      border: `2px solid grey`,
      background: sunColor,
      borderRadius: '50%',
      height: `${sunDim}px`,
      width: `${sunDim}px`,
      top: sunTop,
      right: `${sunRight}px`,
    }

    const bottomCloudsTopOffset = skylineTop - 200
    const middleListTopOffset = skylineTop / 2 - 400

    const middleListContainerStyle = {
      position: 'absolute',
      top: `${middleListTopOffset}px`,
      width: '80%',
      display: 'flex',
      flexDirection: 'column',
      //border: '1px solid magenta'
    }

    return (
      <div className="App">

        <div className="clouds-top">
          { this.state.cloudsFireTop
            ? this.renderClouds(0, true)
            : null
          }
        </div>

        <div className="center-container">

          <div className='center-container'>
            <p style={alHeaderStyle}>
              sw portfolio
            </p>


            <div style={ bulletStyle }>
              <div>
                experienced SDET • indie video game dev
              </div>
                { this.props.company }
            </div>
          </div>

          <div style={chapmanContainerStyle}>
            <div style={chapmanQuoteStyle}>
              "To go faster: simplify, then add lightness."
            </div>
            <div style={chapmanNameStyle}>
              - Colin Chapman
            </div>
          </div>

        </div>

        <div style={ middleListContainerStyle }>

          <GFL />
          <FutoSpec />
          <Management />


        </div>


        <BottomClouds topOffset={ bottomCloudsTopOffset } />


        <div style={ yellowSunStyle }>
        </div>

        <div style={ skylineContainerStyle }>
            <img src={oaklandSkyline} width={skylineWidth} alt="Oakland Skyline" id="oakland-skyline-image" />
        </div>
      </div>
    )
  }
}
